export const projects = [
  
  {
    id: 1,
    img: "https://i.ibb.co/tsrpDYQ/gym.png",
    link: "https://fitness-service-static.onrender.com/",
  },
  
  {
    id: 5,
    img: "https://i.ibb.co/vm9bzQK/screencapture-cheerful-kleicha-df2c43-netlify-app-2022-07-31-23-26-27.png",
    link: "https://dress-up-main.netlify.app/",
  },
  {
    id: 2,
    img: "https://i.ibb.co/G2D2TxQ/bank.png",
    link: "https://basic-banking-service.onrender.com/ ",
  },
  {
    id: 3,
    img: "https://i.ibb.co/2sfvNt2/screencapture-stackup-netlify-app-2022-05-06-14-17-02.png",
    link: "https://stack-up-client.netlify.app/",
  },
  {
    id: 4,
    img: "https://i.ibb.co/h1spb4r/cater.png",
    link: "https://sandeep8093.github.io/Basic-Catering.github.io/",
  },
];

export const experience =[
  
  {
    id:1,
    company: "Anicca Data Science Solutions" ,
    dates: "15 January 2023 - 15 June 2023",
    duties:[  "Developed user authentication APIs using Flask and implemented JSON Web Tokens (JWT) for enhanced security. Implemented a scheduler for sending subscription emails at specific intervals. Conducted code testing and debugging to optimize performance and ensure a bug-free application. Contributed to the migration to a micro-services architecture by implementing multiple Flask instance"] ,
    title:"Software Development Intern",
    website:"https://www.banao.tech/"
  },
  {
    id:2,
    company: "Bookmatic Private Limited" ,
    dates: "20 July 2022 - 15 October 2022",
    duties:[  "Collaborated on developing REST APIs for a SAAS-based accounting and inventory management software. Acquired knowledge of PostgreSQL for Fin-tech applications while working on the project. Created comprehensive documentation for backend API specifications and guidelines to facilitate integration and interoperability"] ,
    title:"NodeJs Development Intern",
    website:"https://www.banao.tech/"
  },

  {
    id:3,
    company: "Across The Globe" ,
    dates: "15 September 2021 - 15 March 2022",
    duties:[  "Designed and developed a social media website where users with similar interests can connect. Developed a referential database structure and utilized AWS S3, MVC pattern, and JWT for storage and authentication"] ,
    title:"NodeJs Development Intern",
    website:"https://www.banao.tech/"
  }
  
  

];
